import { Link } from "react-router-dom";
import React from 'react';

const TeamSection = () => {
  return (
    <section className="team-section space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-7">
            <div className="heading-text">
              <h4 className="heading center-heading">
                AWL India empowers your logistics teams
              </h4>
            </div>
          </div>
        </div>

        {/* Section 1 */}
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="image-section" >
              <img src="/assets/images/service-img1.webp" className="img-responsive" alt="AI Freight Procurement Analyst" loading="lazy"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="content">
              <span className="subtitle">Negotiate better</span>
              <h3 className="heading">Leading AI Freight Procurement Provider Analyst</h3>
              <p>
                The future of sustainable logistics lies in the integration of innovative technologies, eco-friendly transportation methods, and optimized supply chain strategies. With the rise of electric and hydrogen-powered vehicles, companies are reducing carbon footprints while maintaining efficiency.
              </p>
              <Link to="/freight-forwarding" className="theme-btn">
                Learn More
              </Link>
            </div>
          </div>
        </div>

        {/* Section 2 */}
        <div className="row align-items-center row-reverse">
          <div className="col-md-5">
            <div className="content">
              <span className="subtitle">AWL India</span>
              <h3 className="heading">Global Warehousing Expert</h3>
              <p>
                AWL India  can manage your transportation planning & execution
                to deliver a compelling customer experience with optimal
                resource utilization.
              </p>
              <Link to="/warehousing" className="theme-btn">
                Discover Now
              </Link>
            </div>
          </div>
          <div className="col-md-7">
            <div className="image-section"  >
              <img src="/assets/images/service-img2.webp" className="img-responsive" alt="Global Warehousing Expert" loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Section 3 */}
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="image-section"  >
              <img src="/assets/images/service-img3.webp" className="img-responsive" alt="AI Powered Supply Chain Solutions" loading="lazy" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="content">
              <span className="subtitle">Control costs</span>
              <h3 className="heading">AI Powered Supply Chain Solutions</h3>
              <p>
                An AI Freight Audit & Pay Specialist is a cutting-edge solution
                that automates freight auditing and payment processes for
                logistics and supply chain businesses. Using advanced AI
                algorithms, this system accurately verifies freight invoices,
                detects discrepancies and overcharges, and streamlines
                payments.
              </p>
              <Link to="/supply-chain-management" className="theme-btn">
                Learn More
              </Link>
            </div>
          </div>
        </div>

        {/* Section 4 */}
        <div className="row align-items-center row-reverse bottom-rows">
          <div className="col-md-5">
            <div className="content">
              <span className="subtitle">Drive impact</span>
              <h3 className="heading">Smart Omnichannel Inventory</h3>
              <p>
                A Freight Insights Analyst plays a crucial role in analyzing
                logistics and supply chain data to help businesses optimize
                costs, improve efficiency, and make strategic decisions. Using
                AI-driven tools and data analytics, they examine freight costs,
                route efficiency, and carrier performance to identify trends
                and discrepancies.
              </p>
              <Link to="/omnichannel-ecommerce-logistics-solution" className="theme-btn">
                Discover Now
              </Link>
            </div>
          </div>
          <div className="col-md-7">
            <div className="image-section" >
              <img src="/assets/images/service-img4.webp" className="img-responsive" alt="Smart Omnichannel Inventory" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
